import {
  createKeyedAsyncCache,
  mapAsync,
} from "@/components/canvas/leftSide/import/Postgres/keyedAsyncCache";
import {
  TablePreview,
  TablePreviewState,
} from "@/components/canvas/leftSide/import/Connections/tablePreview";
import { fetchTableColumns, TableColumnsResponse } from "./appSearchApi";

const cache = createKeyedAsyncCache<[string], TableColumnsResponse>({
  keyFn: (tableId) => tableId,
  fetcher: (tableId) => fetchTableColumns(tableId),
  fallbackError: "Failed to load columns",
});

export const toTablePreview = (
  tableName: string,
  response: TableColumnsResponse,
): TablePreview => ({
  name: tableName,
  columns: response.columns.map((column, index) => ({
    key: index,
    name: column.name ?? "(unnamed)",
    typeLabel: column.type || "—",
    kind: column.kind,
  })),
  rowCount: response.active_rows ?? null,
});

export const useSearchTableColumns = (
  tableId: string,
  tableName: string,
): { preview: TablePreviewState; ensureLoaded: () => void } => {
  const { state, ensureLoaded } = cache.use([tableId]);
  return {
    preview: mapAsync(state, (response) => toTablePreview(tableName, response)),
    ensureLoaded,
  };
};

export const __resetSearchColumnsCacheForTests = (): void =>
  cache.__resetForTests();
